export interface IResponseLanguages {
  data: {
    languages: []
  };
}
